var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snackbar",class:{
       'snackbar--show': _vm.show,
       'snackbar--info': _vm.info,
       'snackbar--error': _vm.error,
       'snackbar--success': _vm.success
     }},[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"align-self-center",attrs:{"cols":"2","xs":"2","sm":"1","md":"1"}},[(_vm.info)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-alert")]):_vm._e(),(_vm.error)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-alert")]):_vm._e()],1),_c('v-col',{attrs:{"cols":"10","xs":"10","sm":"6","md":"8"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }